import { render, staticRenderFns } from "./GameResultDetail.vue?vue&type=template&id=150ce0cf&scoped=true"
import script from "./GameResultDetail.vue?vue&type=script&lang=js"
export * from "./GameResultDetail.vue?vue&type=script&lang=js"
import style0 from "./GameResultDetail.vue?vue&type=style&index=0&id=150ce0cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150ce0cf",
  null
  
)

export default component.exports